import axios from "axios";
import {
  Paper,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  Modal,
  Box,
  IconButton,
  Backdrop,
  CircularProgress,
  Typography,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MuiAlert from "@mui/material/Alert";
import {
  agregarInvitado,
  editarInvitado,
  getTiposDocumento,
  getTokenControl,
} from "../redux/actions/invitado.actions.js";
import Webcam from "react-webcam";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../media/lomasdeezeiza.png";
import { GuestPhotosSection } from "../components/photos/GuestPhotosSection.js";
import {
  useParams,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min.js";
import { fileToBase64 } from "../helpers/utils.js";
import {
  addVehicleWithImages,
  getDatosMenuPrincipalInvitado,
} from "../redux/actions/vehicle.actions.js";

const Header = ({ isMessage = false }) => (
  <Box sx={{ 
    textAlign: 'center', 
    mb: 3,
    p: 2,
    borderBottom: '1px solid #eee'
  }}>
    <img 
      src={logo} 
      alt="Lomas de Ezeiza" 
      style={{ 
        maxWidth: isMessage ? '400px' : '200px',
        marginBottom: '1rem'
      }} 
    />
    <Typography variant="h6" component="h1" sx={{ color: '#666' }}>
      Bienvenido a Lomas de Ezeiza
    </Typography>
  </Box>
);

const InvitadoForm = (props) => {
  // const hashkey = props.match.params.hashkey;
  const { hashkey } = useParams();
  // console.log("hashkey", hashkey);
  const history = useHistory();
  const [invitationData, setInvitationData] = useState(null);
  // console.log("invitationData", invitationData);
  const [isExistingGuest, setIsExistingGuest] = useState(false);

  const [existingInvitado, setExistingInvitado] = useState(null);
  // console.log("existingInvitado", existingInvitado);

  const [vehicles, setVehicles] = useState([]);

  const [showForm, setShowForm] = useState(false);
  const [showConfirmationMessage, setShowConfirmationMessage] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");

  const [showAttendButton, setShowAttendButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { alta_invitado, error, success } = useSelector(
    (state) => state.invitado
  );
  const tiposDocumentos = useSelector(
    (state) => state.invitado.tiposDocumentos
  );

  const [invitadoData, setInvitadoData] = useState(null);

  const dispatch = useDispatch();

  const [input, setInput] = useState({
    nombre: null,
    apellido: null,
    tipodocumentoid: "",
    nrodocumento: null,
    email: null,
    placadevehiculo: null,
    mayores: "0",
    menores: "0",
  });

  const [showCamera, setShowCamera] = useState(false);

  const [photos, setPhotos] = useState({
    profile: null,
    dni: null,
    license: null,
    vehicle: null,
  });

  const MessageDisplay = ({ message }) => (
    <Box sx={{ 
      maxWidth: 600, 
      margin: '0 auto', 
      p: 2 
    }}>
      <Header isMessage={true} />
      <Paper 
        elevation={3} 
        sx={{ 
          p: 3, 
          textAlign: 'center',
          mt: 2
        }}
      >
        <Typography variant="body1">
          {message}
        </Typography>
      </Paper>
    </Box>
  );

  useEffect(() => {
    const checkInvitation = async () => {
      try {
        // console.log("Checking invitation with hashkey:", hashkey);
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_CONTROL}invitacion?hashkey=${hashkey}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenControl")}`,
            },
          }
        );

        if (!response.data.data || response.data.data.length === 0) {
          console.error("No invitation data received");
          history.push("/404");
          return;
        }

        const invitation = response.data.data[0];

        // Convert UTC times to Argentina time (UTC-3)
        const currentDate = new Date();
        const startTime = new Date(invitation.hora_inicio);
        const endTime = new Date(invitation.hora_fin);

        // Convert UTC to Argentina time by adding 3 hours (since UTC-3 means +3 for local time)
        const argentinaStartTime = new Date(
          startTime.getTime() + 3 * 60 * 60 * 1000
        );
        const argentinaEndTime = new Date(
          endTime.getTime() + 3 * 60 * 60 * 1000
        );

        // Format the time range
        const formatTime = (date) => {
          return date.toLocaleTimeString("es-AR", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        };

        const formatDate = (date) => {
          return date.toLocaleDateString("es-AR", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          });
        };

        if (
          currentDate < argentinaStartTime ||
          currentDate > argentinaEndTime
        ) {
          const validTimeRange = `${formatDate(
            argentinaStartTime
          )} de ${formatTime(argentinaStartTime)} a ${formatTime(
            argentinaEndTime
          )}`;
          setStatusMessage(
            `Invitación inválida. Esta invitación era válida para: ${validTimeRange}`
          );
          history.push("/404");
          return;
        }

        setInvitationData(invitation);

        // If we have an invitadoid, fetch the invitado data directly
        if (invitation.invitadoid) {
          try {
            const invitadoResponse = await axios.get(
              `${process.env.REACT_APP_SERVER_CONTROL}invitado/${invitation.invitadoid}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "tokenControl"
                  )}`,
                },
              }
            );
            setInvitadoData(invitadoResponse.data.data[0]);
            // console.log("Invitado data:", invitadoResponse.data.data);
          } catch (error) {
            console.error("Error fetching invitado data:", error);
          }
        }

        // Modified confirmation check considering invitadoid
        if (invitation.invitadoid) {
          setShowConfirmationMessage(true);
          setShowForm(false);
        } else {
          setShowForm(true);
          setShowConfirmationMessage(false);
        }
      } catch (error) {
        console.error("Error checking invitation:", error);
        history.push("/404");
      }
    };

    if (hashkey) {
      checkInvitation();
    } else {
      console.error("No hashkey provided");
      history.push("/404");
    }
  }, [hashkey, history]);

  const handleAttending = async () => {
    try {
      const token = localStorage.getItem("tokenControl");
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_SERVER_CONTROL}invitado/registroxmail/${invitationData.invitadoid}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          nrodocumento: invitadoData.nrodocumento,
          confirmacion: true,
          invitacionid: invitationData.invitacionid,
        },
      });

      setStatusMessage("Asistencia confirmada correctamente");
      setShowConfirmationMessage(false);
      setShowForm(false);
    } catch (error) {
      console.error("Error updating attendance:", error);
      setStatusMessage("Error al actualizar la asistencia");
    }
  };

  //f handle not attending
  const handleNotAttending = async () => {
    try {
      const token = localStorage.getItem("tokenControl");
      await axios({
        method: "put",
        url: `${process.env.REACT_APP_SERVER_CONTROL}invitado/registroxmail/${invitationData.invitadoid}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
          nrodocumento: invitadoData.nrodocumento,
          confirmacion: false,
          invitacionid: invitationData.invitacionid,
        },
      });

      setStatusMessage("Inasistencia informada correctamente");
      setShowConfirmationMessage(false);
      setShowForm(false);
    } catch (error) {
      console.error("Error updating attendance:", error);
      setStatusMessage("Error al actualizar la asistencia");
    }
  };

  //f handle edit
  const handleEditData = () => {
    setShowForm(true);
    setShowConfirmationMessage(false);
  };

  const handleVehiclePatenteChange = (patente) => {
    setInput((prev) => ({
      ...prev,
      placadevehiculo: patente,
    }));
  };

  const handleVehiclesUpdate = (updatedVehicles) => {
    setVehicles(updatedVehicles);
  };

  const searchInvitado = async (documentNumber) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_CONTROL}invitado?nrodocumento=${documentNumber}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tokenControl")}`,
          },
        }
      );

      if (response.data.status && response.data.data.length > 0) {
        const invitado = response.data.data[0];
        setExistingInvitado(invitado);

        // auto-fill form with existing data
        setInput((prev) => ({
          ...prev,
          nombre: invitado.nombre,
          apellido: invitado.apellido,
          email: invitado.email,
          placadevehiculo: invitado.placadevehiculo,
          tipodocumentoid: invitado.tipodocumentoid,
          nrodocumento: invitado.nrodocumento,
          mayores: invitado.mayores || "0",
          menores: invitado.menores || "0",
        }));

        // Fetch all photos in parallel
        try {
          const [profileUrl, dniUrl, licenseUrl] = await Promise.all([
            fetchGuestPhoto(invitado.invitadoid, "profile"),
            fetchGuestPhoto(invitado.invitadoid, "dni"),
            fetchGuestPhoto(invitado.invitadoid, "license"),
          ]);

          // updates photos state with all fetched photos
          setPhotos({
            profile: profileUrl,
            dni: dniUrl,
            license: licenseUrl,
            vehicle: null, // We can add vehicle later if needed
          });
        } catch (photoError) {
          console.error("Error fetching photos:", photoError);
          setPhotos({
            profile: null,
            dni: null,
            license: null,
            vehicle: null,
          });
        }
      }
    } catch (error) {
      console.error("Error searching for invitado:", error);
    }
  };

  const fetchGuestPhoto = async (guestId, type) => {
    try {
      const token = localStorage.getItem("tokenControl");
      let url;

      switch (type) {
        case "profile":
          url = `${process.env.REACT_APP_SERVER_CONTROL}file?type=invitado&id=${guestId}`;
          break;
        case "dni":
          url = `${process.env.REACT_APP_SERVER_CONTROL}invitado-dni/${guestId}`;
          break;
        case "license":
          url = `${process.env.REACT_APP_SERVER_CONTROL}invitado-licencia/${guestId}`;
          break;
        case "vehicle":
          // Use the same endpoint as PUT but with GET
          url = `${process.env.REACT_APP_SERVER_CONTROL}image-vehiculo/${guestId}`;
          break;
        default:
          return null;
      }

      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      });

      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error(`Error fetching ${type} photo:`, error);
      return null;
    }
  };

  const checkExistingGuest = async () => {
    if (input.tipodocumentoid && input.nrodocumento) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_CONTROL}invitado/search?tipodocumentoid=${input.tipodocumentoid}&nrodocumento=${input.nrodocumento}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("tokenControl")}`,
            },
          }
        );

        if (response.data.data) {
          setIsExistingGuest(true);
          // Fetch guest photos
          const guestId = response.data.data.id;
          const [profile, dni, license, vehicle] = await Promise.all([
            fetchGuestPhoto(guestId, "profile"),
            fetchGuestPhoto(guestId, "dni"),
            fetchGuestPhoto(guestId, "license"),
            fetchGuestPhoto(guestId, "vehicle"),
          ]);

          // Update form with existing data
          setInput(response.data.data);
          setPhotos({
            profile,
            dni,
            license,
            vehicle,
          });
        }
      } catch (error) {
        console.error("Error checking existing guest:", error);
      }
    }
  };

  const handleShowCamera = () => {
    setShowCamera(true);
  };

  const handleCloseCamera = () => {
    setShowCamera(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));

    // If changing nrodocumento and it's complete (length > 6)
    if (name === "nrodocumento" && value.length > 6 && input.tipodocumentoid) {
      searchInvitado(value);
    }
  };

  const handleOnClick = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    try {
      const guestInfo = {
        nombre: input.nombre,
        apellido: input.apellido,
        nrodocumento: input.nrodocumento,
        email: input.email,
        placadevehiculo: input.placadevehiculo,
        tipodocumentoid: input.tipodocumentoid,
        mayores: input.mayores,
        menores: input.menores,
        hashkey: hashkey,
      };

      if (existingInvitado) {
        // First update the invitado
        await dispatch(
          editarInvitado(
            guestInfo,
            existingInvitado.invitadoid,
            existingInvitado.nrodocumento,
            photos,
            invitationData.invitacionid
          )
        );

        // Then handle vehicles
        if (vehicles.length > 0) {
          for (const vehicle of vehicles) {
            const vehicleInfo = {
              ...vehicle,
              invitadoid: existingInvitado.invitadoid,
            };
            // console.log("Sending vehicle with invitadoid:", vehicleInfo);
            await dispatch(addVehicleWithImages(vehicleInfo, vehicle.images));
          }
        }
      } else {
        // For new invitado, same pattern
        const response = await dispatch(
          agregarInvitado(guestInfo, hashkey, photos, invitationData?.personaid)
        );
        const invitadoId = response.data.id;
        // console.log("Created invitado with ID:", invitadoId);

        if (vehicles.length > 0) {
          for (const vehicle of vehicles) {
            const vehicleInfo = {
              ...vehicle,
              invitadoid: invitadoId,
            };
            // console.log("Sending vehicle with invitadoid:", vehicleInfo);
            await dispatch(addVehicleWithImages(vehicleInfo, vehicle.images));
          }
        }
      }
      setIsLoading(false);
      handleClickAlert();
    } catch (error) {
      console.error("Error saving guest and vehicles:", error);
    }
  };

  const handlePhotosUpdate = (updatedPhotos) => {
    // console.log("Photos received in form:", updatedPhotos); // Debug log
    setPhotos(updatedPhotos);
  };

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const [open, setOpen] = React.useState(true);

  const videoConstraints = {
    width: 200,
    height: 200,
    facingMode: "user",
  };

  const [picture, setPicture] = useState("");
  const webcamRef = React.useRef(null);
  const capture = React.useCallback(() => {
    const pictureSrc = webcamRef.current.getScreenshot();
    setPicture(pictureSrc);
  });

  const handleClickAlert = () => {
    setOpen(true);
  };

  const handleCloseAlert = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getTiposDocumento());
    dispatch(getTokenControl());
  }, []);

  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" color="inherit">
          Guardando información...
        </Typography>
      </Backdrop>

      {/* {statusMessage && (
        <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
          <Header />
          <MuiAlert severity="info">{statusMessage}</MuiAlert>
        </Paper>
      )} */}

{statusMessage && (
        <Box sx={{ maxWidth: 600, margin: '0 auto', p: 2 }}>
          <Header isMessage={true}/>
          <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
            <MuiAlert severity="info">{statusMessage}</MuiAlert>
          </Paper>
        </Box>
      )}

      {/* {showConfirmationMessage && (
        <Paper elevation={3} sx={{ p: 3, mb: 2 }}>
          <Box sx={{ textAlign: "center" }}>
            <h2>
              {invitationData.confirmacion
                ? "Usted ya ha confirmado asistencia a este evento"
                : "Usted ha indicado que no asistirá a este evento"}
            </h2>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                gap: 2,
                justifyContent: "center",
              }}
            >
              {invitationData.confirmacion ? (
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleNotAttending}
                  sx={{ color: "white" }}
                >
                  No asistiré
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAttending}
                  sx={{ color: "white" }}
                >
                  Asistiré
                </Button>
              )}
              <Button
                variant="outlined"
                color="primary"
                onClick={handleEditData}
              >
                Editar datos
              </Button>
            </Box>
          </Box>
        </Paper>
      )} */}

{showConfirmationMessage && (
        <Box sx={{ maxWidth: 600, margin: '0 auto', p: 2 }}>
          <Header isMessage={true}/>
          <Paper elevation={3} sx={{ p: 3, mb: 2 }}>
            <Box sx={{ textAlign: "center" }}>
              <h2>
                {invitationData.confirmacion
                  ? "Usted ya ha confirmado asistencia a este evento"
                  : "Usted ha indicado que no asistirá a este evento"}
              </h2>
              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  gap: 2,
                  justifyContent: "center",
                }}
              >
                {invitationData.confirmacion ? (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleNotAttending}
                    sx={{ color: "white" }}
                  >
                    No asistiré
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAttending}
                    sx={{ color: "white" }}
                  >
                    Asistiré
                  </Button>
                )}
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleEditData}
                >
                  Editar datos
                </Button>
              </Box>
            </Box>
          </Paper>
        </Box>
      )}

      {showForm && (
        <section
          className="container"
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "20px",
          }}
        >
          {!success ? (
            <div
              className="form-container-marca"
              style={{
                maxWidth: "600px",
                width: "100%",
              }}
            >
              {/* {welcome and logo} */}
              <div
                style={{
                  textAlign: "center",
                  marginBottom: "2rem",
                }}
              >
                <img
                  src={logo}
                  alt="Logo Lomas de Ezeiza"
                  style={{
                    height: "150px",
                    marginBottom: "1.5rem",
                  }}
                />
                <h1
                  style={{
                    color: "#1a237e",
                    fontSize: "1.8rem",
                    marginBottom: "1rem",
                    fontWeight: "500",
                  }}
                >
                  Control de Acceso - Lomas de Ezeiza
                </h1>
                <p
                  style={{
                    color: "#455a64",
                    fontSize: "1.1rem",
                    lineHeight: "1.5",
                    maxWidth: "500px",
                    margin: "0 auto",
                  }}
                >
                  Para agilizar su ingreso, por favor complete el
                  siguiente formulario con sus datos.
                </p>
              </div>
              {error && (
                <div
                  style={{
                    backgroundColor: "#ffebee",
                    color: "#c62828",
                    padding: 10,
                    borderRadius: 10,
                    marginBottom: 20,
                  }}
                >
                  <p>
                    {error ||
                      "Ha ocurrido un error al procesar su solicitud. Por favor, intente nuevamente."}
                  </p>
                </div>
              )}

              {existingInvitado && (
                <div
                  style={{
                    backgroundColor: "#e3f2fd",
                    color: "#1976d2",
                    padding: 10,
                    borderRadius: 10,
                    marginBottom: 20,
                  }}
                >
                  <p>
                    Se encontró un registro existente. Por favor, verifique sus
                    datos y confírmelos.
                  </p>
                </div>
              )}

              <Paper className="form-marca">
                <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                  <InputLabel id="tipodocumento-select-label">
                    Tipo documento
                  </InputLabel>
                  <Select
                    labelId="tipodocumento-select-label"
                    label="Tipo documento"
                    // size="small"
                    name="tipodocumentoid"
                    value={input.tipodocumentoid || ""}
                    onChange={(e) => handleChange(e)}
                    color="secondary"
                  >
                    <MenuItem value="">Seleccione una opcion</MenuItem>
                    {tiposDocumentos &&
                      tiposDocumentos.map((t) => (
                        <MenuItem
                          value={t.tipodocidentidadid}
                          key={t.tipodocidentidadid}
                        >
                          {t.nombre}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <TextField
                  label="Documento"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="nrodocumento"
                  value={input.nrodocumento || ""}
                  onChange={(e) => handleChange(e)}
                  error={input.nrodocumento == ""}
                  color="secondary"
                  InputLabelProps={{
                    style: {
                      marginBottom: 10,
                      marginTop: -7,
                    },
                  }}
                  inputProps={{
                    style: {
                      height: 40,
                      fontSize: 17,
                    },
                  }}
                />

                {/* Upload Files Section */}
                <GuestPhotosSection
                  onPhotoUpdate={handlePhotosUpdate}
                  initialPhotos={photos}
                  existingInvitado={existingInvitado}
                  onVehiclesUpdate={handleVehiclesUpdate}
                  onVehiclePatenteChange={handleVehiclePatenteChange}
                  personaid={
                    existingInvitado ? existingInvitado.invitadoid : null
                  }
                />

                <TextField
                  label="Nombre"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="nombre"
                  value={input.nombre || ""}
                  onChange={(e) => handleChange(e)}
                  error={input.nombre == ""}
                  color="secondary"
                  InputLabelProps={{
                    style: {
                      marginBottom: 10,
                      marginTop: -7,
                    },
                  }}
                  inputProps={{
                    style: {
                      height: 40,
                      fontSize: 17,
                    },
                  }}
                />
                <TextField
                  label="Apellido"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="apellido"
                  value={input.apellido || ""}
                  onChange={(e) => handleChange(e)}
                  error={input.apellido == ""}
                  color="secondary"
                  InputLabelProps={{
                    style: {
                      marginBottom: 10,
                      marginTop: -7,
                    },
                  }}
                  inputProps={{
                    style: {
                      height: 40,
                      fontSize: 17,
                    },
                  }}
                />

                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="email"
                  value={input.email || ""}
                  onChange={(e) => handleChange(e)}
                  error={input.email == ""}
                  color="secondary"
                  InputLabelProps={{
                    style: {
                      marginBottom: 10,
                      marginTop: -7,
                    },
                  }}
                  inputProps={{
                    style: {
                      height: 40,
                      fontSize: 17,
                    },
                  }}
                />
                <TextField
                  label="Placa vehiculo"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  name="placadevehiculo"
                  value={input.placadevehiculo || ""}
                  onChange={(e) => handleChange(e)}
                  error={input.placadevehiculo == ""}
                  color="secondary"
                  InputLabelProps={{
                    style: {
                      marginBottom: 10,
                      marginTop: -7,
                    },
                  }}
                  inputProps={{
                    style: {
                      height: 40,
                      fontSize: 17,
                    },
                  }}
                />

                <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                  <InputLabel id="adultos-select-label">
                    Adultos acompañantes
                  </InputLabel>
                  <Select
                    labelId="adultos-select-label"
                    label="Adultos acompañantes"
                    name="mayores"
                    value={input.mayores || "0"}
                    onChange={handleChange}
                    color="secondary"
                  >
                    {[0, 1, 2, 3, 4, 5].map((num) => (
                      <MenuItem value={num.toString()} key={num}>
                        {num}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel id="menores-select-label">
                    Menores acompañantes
                  </InputLabel>
                  <Select
                    labelId="menores-select-label"
                    label="Menores acompañantes"
                    name="menores"
                    value={input.menores || "0"}
                    onChange={handleChange}
                    color="secondary"
                  >
                    {[0, 1, 2, 3, 4, 5].map((num) => (
                      <MenuItem value={num.toString()} key={num}>
                        {num}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Paper>
              <div align="right">
                <Button
                  disabled={
                    input.nombre == null ||
                    input.apellido == null ||
                    input.nrodocumento == null ||
                    input.email == null ||
                    input.tipodocumentoid == null
                  }
                  color="secondary"
                  size="large"
                  variant="contained"
                  onClick={(e) => handleOnClick(e)}
                  sx={{ mt: 3, mb: 3 }}
                >
                  {existingInvitado ? "Confirmar" : "Guardar"}
                </Button>
              </div>
            </div>
          ) : (
            // <div
            //   style={{
            //     backgroundColor: "#C7E8CA",
            //     color: "#539165",
            //     padding: 10,
            //     borderRadius: 10,
            //   }}
            // >
            //   <header style={{ padding: 10, textAlign: "center" }}>
            //     <h2>
            //       {existingInvitado
            //         ? "Revisión de invitado"
            //         : "Registro de invitado"}
            //     </h2>
            //   </header>
            //   <h3 style={{ padding: 10 }}>
            //     Sus datos han sido{" "}
            //     {existingInvitado ? "actualizados" : "ingresados"} correctamente
            //     y su asistencia confirmada.
            //   </h3>
            //   <h3 style={{ padding: 10, textAlign: "center" }}>
            //     Muchas gracias.
            //   </h3>
            // </div>
            <Box sx={{ maxWidth: 600, margin: '0 auto', p: 2 }}>
  <Header isMessage={true}/>
  <div
    style={{
      backgroundColor: "#C7E8CA",
      color: "#539165",
      padding: 10,
      borderRadius: 10,
    }}
  >
    <header style={{ padding: 10, textAlign: "center" }}>
      <h2>
        {existingInvitado
          ? "Revisión de invitado"
          : "Registro de invitado"}
      </h2>
    </header>
    <h3 style={{ padding: 10, textAlign: "center" }}>
      Sus datos han sido{" "}
      {existingInvitado ? "actualizados" : "ingresados"} correctamente
      y su asistencia confirmada.
    </h3>
    <h3 style={{ padding: 10, textAlign: "center" }}>
      Muchas gracias.
    </h3>
  </div>
</Box>
          )}

          {/* Camera Modal */}
          <Modal
            open={showCamera}
            onClose={handleCloseCamera}
            aria-labelledby="camera-modal"
            aria-describedby="camera-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                borderRadius: "8px",
                boxShadow: 24,
                p: 4,
                maxWidth: "500px",
                width: "90%",
                position: "relative", // Added for absolute positioning of close button
              }}
            >
              <IconButton
                onClick={handleCloseCamera}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "grey.500",
                }}
              >
                <CloseIcon />
              </IconButton>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                {!picture ? (
                  <Webcam
                    audio={false}
                    height={300}
                    ref={webcamRef}
                    width={300}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                  />
                ) : (
                  <img
                    src={picture}
                    alt="Preview"
                    style={{ maxWidth: "300px", maxHeight: "300px" }}
                  />
                )}

                <div style={{ display: "flex", gap: "10px" }}>
                  {picture ? (
                    <>
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setPicture(null)}
                      >
                        Tomar de nuevo
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCloseCamera}
                      >
                        Confirmar
                      </Button>
                    </>
                  ) : (
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={capture}
                    >
                      Tomar foto
                    </Button>
                  )}
                </div>
              </div>
            </Box>
          </Modal>
        </section>
      )}
    </>
  );
};

export default InvitadoForm;
